export default (array, key='id') =>
  array.reduce((dataObj, item) => {
    dataObj[item[key]]=item;
    return dataObj;
}, {});
